import {
  fetchVehicleWiseCardCollection,
  fetchDayWiseCardCollection,
  fetchCardCollectionSummary,
  fetchTotalIssueTicket,
  fetchCardIssued,
  fetchCardRecharged,
} from "../../services/cardCollectionService";
import {
  vehicleWiseCardCollectionFetched,
  cardCollectionSummaryFetched,
  dayWiseCardCollectionFetched,
  totalIssueTicketFetched,
  cardIssuedFetched,
  cardRechargeFetched,
} from "../actions/cardCollectionAction";

import { createAllActionCreators } from "./actionCreatorUtil";

const cardCollectionActionCreators = {
  vehicleWiseCardCollectionListAction: {
    service: fetchVehicleWiseCardCollection,
    action: vehicleWiseCardCollectionFetched,
  },
  dayWiseCardCollectionListAction: {
    service: fetchDayWiseCardCollection,
    action: dayWiseCardCollectionFetched,
  },
  cardCollectionSummaryAction: {
    service: fetchCardCollectionSummary,
    action: cardCollectionSummaryFetched,
  },
  totalIssueTicketOnCardAction: {
    service: fetchTotalIssueTicket,
    action: totalIssueTicketFetched,
  },
  issueCardListAction: {
    service: fetchCardIssued,
    action: cardIssuedFetched,
  },
  issueRechargeCardListAction: {
    service: fetchCardRecharged,
    action: cardRechargeFetched,
  },
};

export const {
  vehicleWiseCardCollectionListAction,
  dayWiseCardCollectionListAction,
  cardCollectionSummaryAction,
  totalIssueTicketOnCardAction,
  issueCardListAction,
  issueRechargeCardListAction,
} = createAllActionCreators(cardCollectionActionCreators);
